import styled from "styled-components/macro";

export const PageTitle = styled.h1`
  margin: 0 0 1.5em 0;
  font-size: 1.5em;
  font-weight: 400;
  line-height: 1.5em;
`;

export const PageSection = styled.h1`
  margin: 0 0 15px 0;
  font-size: 1.2em;
  font-weight: 400;
  line-height: 1.5em;
`;
